// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui.basic.red.pointing.prompt.label.transition.scale.in[data-v-1e96092d]{margin-left:0;margin-right:0}", ""]);
// Exports
module.exports = exports;
